// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-form-item {\n  margin-bottom: 12px;\n  width: 100%;\n}\n.el-date-editor.el-input {\n  width: 100%;\n}\n.el-form-item__label {\n  width: 180px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.el-form-item__content {\n  width: calc(100% - 180px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}", ""]);
// Exports
module.exports = exports;
